import { render, staticRenderFns } from "./ScoreboardBO.vue?vue&type=template&id=6e58818f"
import script from "./ScoreboardBO.vue?vue&type=script&lang=js"
export * from "./ScoreboardBO.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardBO.vue?vue&type=style&index=0&id=6e58818f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports